import { motion } from "framer-motion";
import {
  Truck, Snowflake, Package, Construction, PackageOpen,
  Handshake, Map, FileText, PhoneCall, Building2,
} from "lucide-react";
import { useLanguage } from "@/i18n/LanguageContext";

const ICONS = [Truck, Snowflake, Package, Construction, PackageOpen, Handshake, Map, FileText, PhoneCall, Building2];

export default function Services() {
  const { t } = useLanguage();
  return (
    <section id="services" data-testid="services-section" className="relative py-24 md:py-32 bg-ink-soft">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="max-w-3xl">
          <div className="text-gold text-sm uppercase tracking-[0.3em] font-semibold mb-4">{t.services.eyebrow}</div>
          <h2 className="font-heading text-4xl sm:text-5xl md:text-6xl text-white leading-[0.95] break-words">
            {t.services.headingLine1}
            <br />
            <span className="text-gold">{t.services.headingLine2}</span>
          </h2>
          <p className="mt-6 text-white/70 text-base md:text-lg max-w-2xl">{t.services.sub}</p>
        </div>

        <div className="mt-14 grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6 md:gap-8">
          {t.services.items.map((s, i) => {
            const Icon = ICONS[i] || Truck;
            return (
              <motion.div
                key={s.title}
                data-testid={`service-card-${i}`}
                initial={{ opacity: 0, y: 30 }}
                whileInView={{ opacity: 1, y: 0 }}
                viewport={{ once: true, margin: "-50px" }}
                transition={{ duration: 0.5, delay: (i % 3) * 0.1 }}
                className="group relative bg-ink-card rounded-lg p-8 border-t-4 border-transparent hover:border-gold transition-all duration-300 hover:-translate-y-2 hover:shadow-[0_14px_40px_rgba(255,215,0,0.15)]"
              >
                <div className="absolute inset-x-0 top-0 h-1 bg-gradient-to-r from-transparent via-gold/0 to-transparent group-hover:via-gold/80 transition-all duration-500" />
                <div className="w-12 h-12 rounded bg-ink flex items-center justify-center text-gold mb-6 group-hover:scale-110 transition-transform">
                  <Icon size={24} />
                </div>
                <h3 className="font-heading text-2xl text-white uppercase tracking-wide">{s.title}</h3>
                <p className="mt-3 text-white/60 text-sm leading-relaxed">{s.desc}</p>
              </motion.div>
            );
          })}
        </div>
      </div>
    </section>
  );
}
